import styled from 'styled-components';
import { colors } from '../../../../config/styles';
import { SingleSelectMenu } from '../../../../components/Dropdown';
import NumberInput from '../../../../components/Form/NumberInput';
import { theme } from '../../../../styles/theme';
import {
  DataModelerTabPanel,
  verticalWrapperStyles,
} from '../DataModelerCommonUI';
import { PrimaryButton } from '../../../../components/Button';

export const DataSourceTab = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
`;

export const DataSourceForm = styled(DataModelerTabPanel)`
  ${verticalWrapperStyles};
`;

export const EndDateDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
`;

export const WideSingleSelectMenu = styled(SingleSelectMenu)`
  width: 100%;
  max-width: 100%;
`;

export const DaysNumberInput = styled(NumberInput)`
  width: 84px;
  max-width: 84px;
`;

export const TestConnectionForm = styled(DataModelerTabPanel)`
  ${verticalWrapperStyles};
`;

export const TestConnectionButton = styled(PrimaryButton)`
  width: 100%;
`;

export const TestResults = styled.div<{
  $isError: boolean;
  $noResults: boolean;
}>`
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ $isError, $noResults }) =>
    $isError
      ? colors.mainError
      : $noResults
        ? theme.colors.secondary800
        : theme.colors.mainBlue};
`;
